import {
  CARD,
  LAYOUT_LIST,
  LAYOUT_TABLE,
  TABLE_ROW,
  TableRowDefinition,
  TEXT
} from '../items';
import { Translator } from '../Translator';
import { translate } from './translate';

export const Text5: Translator = sequence => {
  const root = translate(sequence, () => null);
  const tableRow: TableRowDefinition[] = [];
  const headerForTable: { title?: string; subtitle?: string } = {};

  sequence.items?.forEach((item: Record<string, unknown>, trIndex: number) => {
    if (item.__typename == 'Text') {
      headerForTable.title = item.title as string;
      headerForTable.subtitle = item.subtitle as string;
    }

    if (item.__typename == 'List') {
      if (!tableRow[0])
        tableRow[0] = {
          type: TABLE_ROW,
          id: 'table_header',
          values: {},
          items: []
        };

      tableRow[0].items.push({
        type: TEXT,
        id: `${trIndex}`,
        items: [],
        values: {
          variant: 'heading2',
          value: item.title
        }
      });

      let index = 1;

      ((item && (item.items as unknown[])) || []).forEach(
        (row: Record<string, unknown>, tdIndex: number) => {
          if (!tableRow[index])
            tableRow[index] = {
              type: TABLE_ROW,
              id: `tr_${tdIndex}`,
              values: {},
              items: []
            };

          tableRow[index].items.push({
            type: TEXT,
            id: `td_${index}_${tdIndex}`,
            items: [],
            values: {
              value: row.title
            }
          });

          index++;
        }
      );
    }
  });

  root.items.push({
    id: 'LAYOUT_LIST',
    type: LAYOUT_LIST,
    values: {
      align: 'center'
    },
    items: [
      {
        type: CARD,
        id: '1_title',
        values: {
          clearStyles: 'lg',
          width: 'auto',
          height: 'auto',
          align: 'left'
        },
        items: [
          {
            type: TEXT,
            id: 'title',
            items: [],
            values: {
              value: headerForTable.title,
              variant: 'heading1'
            }
          }
        ]
      },
      {
        type: CARD,
        id: '1',
        values: {
          clearStyles: 'lg',
          height: 'auto',
          width: '100%'
        },
        items: [
          {
            type: LAYOUT_TABLE,
            id: 'table',
            values: [],
            items: tableRow
          }
        ]
      }
    ]
  });

  return root;
};
